<template>
  <div id="dataThreshold" class="animated fadeIn h-100">
    <b-tabs class="h-100" content-class="hc-sub36">
      <b-tab title="데이터 임계치 이력" class="p-0 h-100">
        <div>
          <b-card class="h-100 m5 default-border1" body-class="h-100 p-0">
            <div class="searchBox">
              <div>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
                <!-- <label>디바이스</label>
                <b-form-select
                  class="w200"
                  v-model="search.deviceid"
                  :options="search.deviceOptions"
                ></b-form-select> -->
                <label>임계치 종류</label>
                <b-form-select
                  class="w200"
                  v-model="search.thrid"
                  :options="search.thresholdOptions"
                  required
                ></b-form-select>
                <label>기간</label>
                <b-form-input
                  type="date"
                  class="w200"
                  v-model="search.stdate"
                  required
                ></b-form-input>
                <label>~</label>
                <b-form-input
                  type="date"
                  class="w200"
                  v-model="search.eddate"
                  required
                ></b-form-input>
              </div>
              <div>
                <b-button class="searchBtn" @click="getData1">조회</b-button>
              </div>
            </div>
          </b-card>
        </div>
        <div class="chartarea">
          <b-card
            class="h-100 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">데이터 임계치 발생 차트</h6>
            <div id="thrHistChart" class="graph default-border-top1"></div>
          </b-card>
        </div>
        <div class="hc-sub460">
          <b-card
            class="h-100 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">이력</h6>
            <ag-grid-vue
              class="ag-theme-balham"
              :gridOptions="thresholdGridOptions"
            ></ag-grid-vue>
          </b-card>
        </div>
      </b-tab>
      <b-tab title="센서별 임계치 이력" class="p-0 h-100">
        <div>
          <b-card class="h-100 m5 default-border1" body-class="h-100 p-0">
            <div class="searchBox">
              <div>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w150"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
                <label>구조물</label>
                <vue-select
                  class="select-container w150"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
                <label>디바이스</label>
                <b-form-select
                  class="w150"
                  v-model="search.deviceid"
                  :options="search.deviceOptions"
                  required
                ></b-form-select>
                <label>센서</label>
                <b-form-select
                  class="w140"
                  v-model="search.channel"
                  :options="search.sensorOptions"
                  required
                ></b-form-select>
                <label>데이터 타입</label>
                <b-form-select
                  class="w100"
                  v-model="search.datatype"
                  :options="search.datatypeOptions"
                  required
                ></b-form-select>
                <label>임계치 종류</label>
                <b-form-select
                  class="w100"
                  v-model="search.thrid"
                  :options="search.thresholdOptions"
                  required
                ></b-form-select>
                <label>기간</label>
                <b-form-input
                  type="date"
                  class="w170"
                  v-model="search.stdate"
                  required
                ></b-form-input>
                <label>~</label>
                <b-form-input
                  type="date"
                  class="w170"
                  v-model="search.eddate"
                  required
                ></b-form-input>
              </div>
              <div>
                <b-button class="searchBtn" @click="getData">조회</b-button>
              </div>
            </div>
          </b-card>
        </div>
        <div class="chartarea">
          <b-card
            class="h-100 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">변화량 차트</h6>
            <div id="senThrHistChart" class="graph default-border-top1"></div>
          </b-card>
        </div>
        <div class="hc-sub460">
          <b-card
            class="h-100 m5 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">이력</h6>
            <ag-grid-vue
              class="ag-theme-balham"
              :gridOptions="senThrGridOptions"
            ></ag-grid-vue>
          </b-card>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal
      id="detailInfoModal"
      :title="defaultInfo.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <detail-info-modal :defaultInfo="defaultInfo"></detail-info-modal>
    </b-modal>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import comboRenderer from "../common/cellComboRenderer";
import detailInfoModal from "./ThresholdDetailModal.vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
    detailInfoModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getCenterBus",
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  data() {
    return {
      search: {
        projectid: null,
        stid: null,
        deviceid: null,
        channel: null,
        devicetype: null,
        datatype: null,
        thrid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stidOptions: [{ value: null, text: "선택" }],
        deviceOptions: [{ value: null, text: "선택" }],
        sensorOptions: [{ value: null, text: "선택" }],
        datatypeOptions: [{ value: null, text: "선택" }],
        thresholdOptions: [
          { value: null, text: "선택" },
          { value: "일 변화량 임계치 이상", text: "일 변화량" },
          { value: "트랜드 변화량 임계치 이상", text: "트렌드 변화량" },
          // { value: '충격 이벤트 임계치 이상', text: '충격 이벤트' }
        ],
        stdate: null,
        eddate: null,
      },
      thresholdGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        rowHeight: 35,
        headerHeight: 35,
        enableSorting: true,
        enableColResize: true,
        onRowDoubleClicked: (params) => {
          var sel = params.api.getSelectedRows()[0];
          this.openDetailInfoModal(sel);
        },
        suppressHorizontalScroll: true,
      },
      senThrGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        rowHeight: 35,
        headerHeight: 35,
        enableSorting: true,
        enableColResize: true,
        onRowDoubleClicked: (params) => {
          var sel = params.api.getSelectedRows()[0];
          this.openDetailInfoModal(sel);
        },
        suppressHorizontalScroll: true,
      },
      defaultInfo: {},
      isFirstCall: true,
    };
  },
  watch: {
    "search.projectid"() {
      this.getStidList();
    },
    "search.stid"() {
      this.getDeviceList();
    },
    "search.deviceid"() {
      this.getSensorList();
    },
    "search.channel"() {
      this.setDataType(this.search.devicetype);
    },
  },
  created() {
    this.getProjectList();
    this.search.thrid = this.search.thresholdOptions[1].value;
    this.search.stdate = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.search.eddate = moment().format("YYYY-MM-DD");
  },
  beforeMount() {
    this.thresholdGridOptions.columnDefs = [
      { headerName: "발생시간", field: "occurtime" },
      { headerName: "장애이름", field: "alarmname" },
      {
        headerName: "등급",
        field: "alarmlevel",
        cellRendererFramework: comboRenderer,
        cellRendererParams: {
          values: [
            { value: "MIN", text: "●" },
            { value: "MAJ", text: "●" },
            { value: "CRI", text: "●" },
          ],
        },
        cellStyle: (params) => {
          if (params.value === "CRI") {
            return {
              color: "#f00",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          } else if (params.value === "MAJ") {
            return {
              color: "#ff8510",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          } else if (params.value === "MIN") {
            return {
              color: "#ff4",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          }
        },
        width: 100,
      },
      { headerName: "구조물", field: "stname" },
      { headerName: "디바이스ID", field: "deviceid" },
      { headerName: "디바이스이름", field: "devicename" },
      { headerName: "CH#", field: "channel", width: 100 },
      { headerName: "발생위치", field: "alarmsource" },
      { headerName: "장애정보", field: "detailinfo" },
      { headerName: "데이터타입", field: "datatype", hide: true },
      { headerName: "디바이스타입", field: "devicetype", hide: true },
    ];
    this.senThrGridOptions.columnDefs = [
      { headerName: "발생시간", field: "occurtime" },
      { headerName: "장애이름", field: "alarmname" },
      {
        headerName: "등급",
        field: "alarmlevel",
        cellRendererFramework: comboRenderer,
        cellRendererParams: {
          values: [
            { value: "MIN", text: "●" },
            { value: "MAJ", text: "●" },
            { value: "CRI", text: "●" },
          ],
        },
        cellStyle: (params) => {
          if (params.value === "CRI") {
            return {
              color: "#f00",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          } else if (params.value === "MAJ") {
            return {
              color: "#ff8510",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          } else if (params.value === "MIN") {
            return {
              color: "#ff4",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          }
        },
        width: 100,
      },
      { headerName: "구조물", field: "stname" },
      { headerName: "디바이스ID", field: "deviceid" },
      { headerName: "디바이스이름", field: "devicename" },
      { headerName: "CH#", field: "channel", width: 100 },
      { headerName: "발생위치", field: "alarmsource" },
      { headerName: "장애정보", field: "detailinfo" },
      { headerName: "데이터타입", field: "datatype", hide: true },
      { headerName: "디바이스타입", field: "devicetype", hide: true },
    ];
  },
  mounted() {
    if (this.getSelectedDataStartDate) {
      this.search.stdate = this.getSelectedDataStartDate;
    }
    if (this.getSelectedDataEndDate) {
      this.search.eddate = this.getSelectedDataEndDate;
    }
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    getProjectList() {
      let reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              if (data[i].projectid === this.search.projectid) {
                options.push({
                  value: data[i].stid,
                  text: data[i].stname,
                });
              } else {
                continue;
              }
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.getDeviceList();
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceList() {
      if (!this.search.stid) {
        this.search.deviceOptions = [{ value: null, text: "선택" }];
        this.search.deviceid = null;
        return;
      }
      let reqBody = {
        projectid: this.search.projectid,
        stid: this.search.stid,
        manage: 2,
      };
      this.$http
        .post("/device/getDeviceList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let devicelist = res.data.data.deviceList;
            let rowData = [{ value: null, text: "선택" }];
            for (let i = 0; i < devicelist.length; i++) {
              rowData.push({
                value: devicelist[i].deviceid,
                text: devicelist[i].devicename,
              });
            }
            this.search.deviceOptions = rowData;
            this.search.deviceid = null;
          } else {
            this.setAlertTitle("디바이스 목록 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorList() {
      if (!this.search.deviceid) {
        this.search.sensorOptions = [{ value: null, text: "선택" }];
        this.search.channel = null;
        return;
      }
      let reqBody = {
        stid: this.search.stid,
        deviceid: this.search.deviceid,
        manage: 2,
      };
      this.$http
        .post("/device/getSensorList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data.sensorList;
            let rowData = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              rowData.push({
                devicetype: data[i].devicetype,
                text: data[i].sensoralias,
                value: data[i].channel, // ? data[i].channel : 0,
              });
            }
            this.search.sensorOptions = rowData;
            this.search.channel = rowData[1].value;
            this.search.devicetype = rowData[1].devicetype;
          } else {
            this.setAlertTitle("센서 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isDynamicSensor: utils.isDynamicSensor,
    isStaticSensor: utils.isStaticSensor,
    setDataType(deviceType) {
      if (this.isDynamicSensor(deviceType)) {
        this.search.datatypeOptions = [
          { value: "anal1", text: "anal1" },
          { value: "anal2", text: "anal2" },
        ];
        this.search.datatype = this.search.datatypeOptions[0].value;
      } else if (this.isStaticSensor(deviceType)) {
        this.search.datatypeOptions = [{ value: "s-v", text: "s-v" }];
        this.search.datatype = "s-v";
      }
      this.search.thrid = this.search.thresholdOptions[1].value;
    },
    getData1() {
      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.stdate);
      this.setSelectedDataEndDate(this.search.eddate);

      this.getThrDataForGrid();
      this.getThrDataForChart();
    },
    getThrDataForGrid() {
      let reqBody = {
        projectid: this.search.projectid,
        stid: this.search.stid,
        // deviceid: this.search.deviceid,
        thrid: this.search.thrid,
        stdate: this.search.stdate,
        eddate: this.search.eddate,
      };
      this.$http
        .post("/event/getThrDataForGrid", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let rowData = [];
            for (let i = 0; i < data.length; i++) {
              rowData.push({
                occurtime: data[i].occurtime,
                alarmname: data[i].alarmname,
                alarmlevel: data[i].alarmlevel,
                stname: data[i].stname,
                deviceid: data[i].deviceid,
                devicename: data[i].devicename,
                channel: data[i].channel,
                alarmsource: data[i].alarmsource,
                sensortype: data[i].sensortype,
                detailinfo: data[i].detailinfo,
                datatype: data[i].datatype,
                devicetype: data[i].devicetype,
              });
            }
            this.thresholdGridOptions.api.setRowData(rowData);
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getThrDataForChart() {
      let reqBody = {
        projectid: this.search.projectid,
        stid: this.search.stid,
        // deviceid: this.search.deviceid,
        thrid: this.search.thrid,
        stdate: this.search.stdate,
        eddate: this.search.eddate,
      };
      this.$http
        .post("/event/getThrDataForChart", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let chghist = res.data.data.chghist;
            if (chghist.length > 0) {
              let chartData = [];
              chartData[0] = { x: [], y: [] };
              let yVal = 0;
              let i = 0;
              for (let j = i; j < chghist.length; j++) {
                if (chghist[j].alarmsource === chghist[i].alarmsource) {
                  chartData[yVal].x.push(chghist[j].occurtime);
                  chartData[yVal].y.push(chghist[j].alarmsource);
                } else {
                  yVal += 1;
                  i = j;
                  j = j - 1;
                  chartData[yVal] = { x: [], y: [] };
                }
              }
              this.$nextTick(() => {
                this.drawDataThrChart(
                  "thrHistChart",
                  {
                    data: chartData,
                    annotation: {
                      yaxis: {
                        text: "센서",
                        x: -0.1,
                        y: 0.5,
                      },
                    },
                  },
                  {
                    xrange: [reqBody.stdate, reqBody.eddate],
                  }
                );
              });
            } else {
              Plotly.purge("thrHistChart");
              this.setAlertTitle("조회 결과 없음");
              this.$bvModal
                .msgBoxOk("조회 결과가 없습니다.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawDataThrChart(id, param, range) {
      let data = [];
      let tickvals = [];
      let colors = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf",
        "#FFC0CB",
        "#EE82EE",
        "#008000",
        "#0000FF",
        "#FF1493",
        "#FF7F50",
        "#BA55D3",
        "#66CDAA",
        "#000080",
        "#FFD700",
      ];
      for (let i = 0; i < param.data.length; i++) {
        data.push({
          x: param.data[i].x,
          y: param.data[i].y,
          mode: "markers",
          name: param.data[i].y[0],
          marker: {
            color: colors[i],
            size: 10,
          },
        });
        tickvals.push(param.data[i].y[0]);
      }
      let layout = chartUtil.setLayout(id, {
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 180
              : 50,
          r: 50,
          t: 40,
          b: 50,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      layout.yaxis.tickvals = tickvals;
      layout.xaxis.tickformat = "%Y-%m-%d %H:%M:%S";
      layout.xaxis.dtick = 86400000.0;
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    getData() {
      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.stdate);
      this.setSelectedDataEndDate(this.search.eddate);

      this.getSenAlarmHistGrid();
      this.getSensorThrHistForChart();
    },
    getSenAlarmHistGrid() {
      let reqBody = {
        stid: this.search.stid,
        deviceid: this.search.deviceid,
        channel: this.search.channel,
        datatype: this.search.datatype,
        thrid: this.search.thrid,
        stdate: this.search.stdate,
        eddate: this.search.eddate,
      };
      this.$http
        .post("/event/getSensorThrAlarmHist", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let rowData = [];
            for (let i = 0; i < data.length; i++) {
              rowData.push({
                alarmlevel: data[i].alarmlevel,
                alarmname: data[i].alarmname,
                stname: data[i].stname,
                devicename: data[i].devicename,
                deviceid: data[i].deviceid,
                occurtime: data[i].occurtime,
                channel: data[i].channel,
                alarmsource: data[i].alarmsource,
                detailinfo: data[i].detailinfo,
                datatype: data[i].datatype,
                devicetype: data[i].devicetype,
              });
            }
            this.senThrGridOptions.api.setRowData(rowData);
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 일변화량 추이
    getSensorThrHistForChart() {
      let reqBody = {
        stid: this.search.stid,
        deviceid: this.search.deviceid,
        channel: this.search.channel,
        datatype: this.search.datatype,
        thrid: this.search.thrid,
        stdate: this.search.stdate,
        eddate: this.search.eddate,
      };
      this.$http
        .post("/event/getSensorThrChgHist", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let chg = res.data.data.chg;
            if (chg.length > 0) {
              let alarmLine = res.data.data.alarmLine;
              let chartData = { x: [], y: [] };
              let lines = {};
              for (let i = 0; i < chg.length; i++) {
                chartData.x.push(chg[i].datatime);
                chartData.y.push(chg[i].chg);
              }
              lines = {
                // init: alarmLine[0].initVal,
                warn: alarmLine[0].warnVal,
                crit: alarmLine[0].critVal,
                dang: alarmLine[0].dangVal,
              };
              this.$nextTick(() => {
                this.drawTimeLineChart(
                  "senThrHistChart",
                  {
                    data: {
                      x: chartData.x,
                      y: chartData.y,
                    },
                    annotation: {
                      yaxis: {
                        text: "변화량",
                        x: -0.04,
                        y: 0.5,
                      },
                    },
                    lines: lines,
                  },
                  {
                    xrange: [reqBody.stdate, reqBody.eddate],
                  }
                );
              });
            } else {
              Plotly.purge("senThrHistChart");
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("조회 결과가 없습니다.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawTimeLineChart(id, param, range) {
      let data = [];
      data.push({
        x: param.data.x,
        y: param.data.y,
        type: "scatter",
        mode: "lines+markers",
        line: { width: 1 },
        name: "",
      });
      data.push({
        x: [range.xrange[1], range.xrange[1], range.xrange[1]],
        y: [param.lines.warn, param.lines.crit, param.lines.dang],
        text: ["주의", "경고", "심각"],
        textposition: "top right",
        mode: "text",
        textfont: {
          color: "#b4b7bd",
        },
        hoverinfo: "none",
      });
      let layout = chartUtil.setLayout(id, {
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 50,
          t: 40,
          b: 50,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      layout.xaxis.tickformat = "%Y-%m-%d";
      // layout.xaxis.range = range.xrange
      layout.shapes = [
        {
          type: "line",
          xref: "paper",
          x0: 0,
          y0: param.lines.warn,
          x1: 1,
          y1: param.lines.warn,
          line: {
            color: "#ff4",
            width: 1,
            dash: "longdash",
          },
        },
        {
          type: "line",
          xref: "paper",
          x0: 0,
          y0: param.lines.crit,
          x1: 1,
          y1: param.lines.crit,
          line: {
            color: "#ff8510",
            width: 1,
            dash: "longdash",
          },
        },
        {
          type: "line",
          xref: "paper",
          x0: 0,
          y0: param.lines.dang,
          x1: 1,
          y1: param.lines.dang,
          line: {
            color: "#f00",
            width: 1,
            dash: "longdash",
          },
        },
      ];
      Plotly.newPlot(id, data, layout, { scrollZoom: true });
    },
    openDetailInfoModal(param) {
      this.defaultInfo = {
        data: param,
        stid: this.search.stid,
        thrid: this.search.thrid,
        title:
          param.stname +
          " / " +
          param.devicename +
          " (" +
          param.alarmsource +
          ") 상세 정보",
      };
      this.$bvModal.show("detailInfoModal");
    },
  },
};
</script>
<style lang="scss">
#dataThreshold {
  padding: 15px;
  .card {
    .card-body {
      padding: 0;
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  & div.ag-theme-balham {
    width: 100%;
    height: 100%;
  }
  .chartarea {
    height: 390px;
  }
  .graph {
    width: 1868px;
    height: 340px;
  }
  .tab-content {
    background-color: #283046;
    border: 0px solid #373b40;
    border-top: 1px solid #373b40;
    height: calc(100% - 36px);
  }
  .nav.nav-tabs {
    height: 36px;
    & .nav-link {
      padding: 4px 16px !important;
      height: 36px;
      font-size: 15px;
      line-height: 26px;
      background-color: #283046;
      border-top: 1px solid #373b40;
      border-bottom: 1px solid #373b40;
      border-left: 1px solid #373b40;
      border-right: 0px solid #373b40;
      color: #626467;
      &.active {
        color: #7367f0;
        background-color: #283046;
        border-top: 1px solid #373b40;
        border-bottom: 0px solid #373b40;
        border-left: 1px solid #373b40;
      }
    }
    & .nav-item:last-child .nav-link {
      border-right: 1px solid #373b40;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/DataThreshold.vue